<div class="mx-1 my-1">
    <div class="row my-row" *ngIf="searchForm">
        <div class="col-sm my-col">
            <div class="card mt-3">
                <div class="card-header">{{ "DIRECTORY.FORM.TITLE" | translate }}</div>
                <div class="card-body">
                    <form [formGroup]="searchForm" novalidate (ngSubmit)="search(searchForm.value)">
                        <div class='form-row mb-3 my-row'>
                            <div class='col-6 col-lg-auto pb-3 my-col'>
                                <mat-form-field class="mx-2">
                                    <input matInput type="text" placeholder="{{ 'FORM.FNAME' | translate }}" formControlName="lname" id="lname">
                                </mat-form-field>
                                <mat-form-field class="mx-2">
                                    <input matInput type="text" placeholder="{{ 'FORM.LNAME' | translate }}" formControlName="fname" id="fname">
                                </mat-form-field>
                                <mat-form-field class="mx-2">
                                    <mat-label>{{ "FORM.BIRTHDATE" | translate }}</mat-label>
                                    <input matInput readonly (focus)="picker.open()" formControlName="dateOfBirth" id="dateOfBirth" [max]="maxDate" [matDatepicker]="picker">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class='form-row mb-3 my-row'>
                            <div class='col-6 col-lg-auto pb-3 my-col'>
                                <mat-form-field class="mx-2">
                                    <input matInput type="text" placeholder="{{ 'FORM.MAIL' | translate }}" formControlName="email" id="email">
                                </mat-form-field>
                                <mat-form-field class="mx-2">
                                    <input matInput type="text" id="city" placeholder="{{ 'FORM.CITY' | translate }}" formControlName="city"
                                    [matAutocomplete]="auto" (blur)="checkCity()">
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="cityClick($event)">
                                        <mat-option *ngFor="let city of filteredOptions | async" [value]="city.nom">
                                            {{city.nom}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class='form-row mb-3 my-row'>
                            <div class='col-6 col-lg-auto pb-3 my-col'>
                                <mat-form-field class="mx-2">
                                    <input matInput type="text" placeholder="{{ 'FORM.INS' | translate }}" formControlName="ins" id="ins">
                                </mat-form-field>
                                <mat-form-field class="mx-2">
                                    <input matInput type="text" placeholder="{{ 'FORM.PHONE' | translate }}" formControlName="phoneNumber" id="phoneNumber">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class='form-row mb-3 my-row'>
                            <div class="col-6 col-lg-auto pb-3 my-col">
                                <mat-form-field appearance="fill">
                                    <mat-label>{{ "DIRECTORY.SELECT-LABEL" | translate }}</mat-label>
                                    <mat-select formControlName="directory" multiple>
                                        <mat-optgroup *ngIf="accessDirectory?.ps && accessDirectory!.ps!.length > 0"
                                        label="{{ 'DIRECTORY.SELECT-GROUP-PS' | translate }}">
                                            <mat-option *ngFor="let access of accessDirectory!.ps" [value]="access.ps">
                                                <span *ngIf="access.ps != userService.currentUser.symfonyUser.id"
                                                [ngStyle]="{'color': access.color == '#ffffff' ? 'black' : access.color}">
                                                    {{ "DIRECTORY.SELECT-LOG" | translate }} {{access.name}}
                                                </span>
                                                <span *ngIf="access.ps == userService.currentUser.symfonyUser.id" class="text-dark">
                                                    {{ "DIRECTORY.SELECT-OWN-LOG" | translate }}
                                                </span>
                                            </mat-option>
                                        </mat-optgroup>
                                        <mat-optgroup *ngIf="accessDirectory?.clients && accessDirectory!.clients!.length > 0"
                                        label="{{ 'DIRECTORY.SELECT-GROUP-CLIENT' | translate }}">
                                            <mat-option *ngFor="let accessClient of accessDirectory!.clients" [value]="accessClient.structure">
                                                {{accessClient.name}}
                                            </mat-option>
                                        </mat-optgroup>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class='form-row mt-3 my-row'>
                            <div class='col my-col'>
                                <button type="submit" class="btn btn-primary mx-1" [disabled]="!searchForm.valid">{{ "BUTTONS.SEARCH" | translate }}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="row my-row" *ngIf="directories">
        <div class="col-12 col-lg-6 my-col">
            <div class="card mt-3">
                <div class="card-header">{{ "DIRECTORY.RESULT.TITLE" | translate }}</div>
                <div class="card-body">
                    <p>{{ "DIRECTORY.RESULT.INFO" | translate }}</p>
                    <ul class='list-group list-group-flush' id='resultat'>
                        <li class="list-group-item" *ngFor="let directory of directories" [ngStyle]="{'background': directory.color}">
                            <div class="row my-row">
                                <div class="col my-col">
                                    <p [ngStyle]="{'color': directory.color == '#ffffff' ? 'black' : 'white', 'font': '1.2em'}"
                                    class="h5">
                                        {{directory.lname}} {{directory.fname}}
                                    </p>
                                </div>
                                <div class="col my-col">
                                    <button type="button" class="btn btn-info mx-1 btn-sm" (click)="open(directory)">
                                        {{ "BUTTONS.PATIENT-INFO" | translate }}
                                    </button>
                                    <button type="button" class="btn btn-success mx-1 btn-sm" (click)="addSignatories(directory)">
                                        {{ "BUTTONS.ADD-SIGNATORY-DIRECTORY" | translate }}
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div *ngIf="directories.length == 0" class="alert alert-info" role="alert">
                        <b>{{ "DIRECTORY.NO-RESULT" | translate }}</b>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-6 my-col">
            <div class="card mt-3">
                <div class="card-header">
                    {{ "DIRECTORY.SELECTION.TITLE" | translate }}
                </div>
                <div class="card-body">
                    <div class='row my-row'>
                        <div class='col my-col'>
                            <h4 class='selection-annuaires' id="dest">{{ "DIRECTORY.SELECTION.SIGNATORIES" | translate }}</h4>
                            <ul *ngIf="signatories">
                                <li *ngFor="let signatory of this.signatories; let index = index" class="h-25">
                                    <h4>
                                        {{ signatory }}
                                        <em class="bi bi-x-circle-fill mx-2" style="color: red" (click)="removeSignatory(signatory)"></em>
                                    </h4>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class='row my-row'>
                        <div class='col my-col'>
                            <button type="button" id="reinit" class='btn btn-danger mx-1'
                              (click)="reinitSignatories()" [disabled]="signatories.length <= 0">
                              {{ "BUTTONS.CLEAR-LIST" | translate }}
                            </button>
                            <button type="button" id="send" class='btn btn-primary mx-1'
                              (click)="toCreate()" [disabled]="signatories.length <= 0">
                              {{ "BUTTONS.VALIDATE" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

